import { inject, Injectable } from '@angular/core';
import { ToastMessageOptions, MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private messageService = inject(MessageService);

  /**
   * Add a toast message to PrimeNG's MessageService.
   *
   * @param message The message to inject into a toast notification.
   */
  addOne(message: ToastMessageOptions) {
    this.messageService.add({
      ...message,
      life: 3000,
    });
  }

  /**
   * Clears all toast notifications.
   */
  clear() {
    this.messageService.clear();
  }

  /**
   * Clears all toast notifications and adds a toast message to PrimeNG's
   * MessageService.
   *
   * @param message The message to inject into a toast notification.
   */
  clearAndAddOne(message: ToastMessageOptions) {
    this.clear();
    this.addOne(message);
  }
}
